import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getFirmById } from "../../Services/Firm";
import IFirm from "../../interfaces/models/IFirm";
import ReferralDetail from "./ReferralDetail";
import ReferralForm from "./ReferralForm";
import ReferralsList from "./ReferralsList";

export function ManageFirmReferralsList() {
  const { id } = useParams();
  const firm = useFirm(id);
  if (!firm?.id) {
    return null;
  }
  const basePath = `/ManageFirm/Referrals/${firm.id}`;
  return (
    <ReferralsList
      variant="staff"
      firmLegacyId={firm.legacyId ? Number(firm.legacyId) : null}
      firmCosmosId={firm.id}
      basePath={basePath}
    />
  );
}

export function ManageFirmReferralForm({ mode }: { mode: "add" | "edit" }) {
  const { id } = useParams();
  const firm = useFirm(id);
  if (!firm?.id) {
    return null;
  }
  return (
    <ReferralForm
      variant="staff"
      mode={mode}
      basePath={`/ManageFirm/Referrals/${firm.id}`}
      lockedFirmCosmosId={firm.id}
    />
  );
}

export function ManageFirmReferralDetail() {
  const { id } = useParams();
  const firm = useFirm(id);
  if (!firm?.id) {
    return null;
  }
  return <ReferralDetail variant="staff" basePath={`/ManageFirm/Referrals/${firm.id}`} />;
}

function useFirm(id: string | undefined): IFirm | null {
  const [firm, setFirm] = useState<IFirm | null>(null);
  useEffect(() => {
    if (!id) {
      return;
    }
    let cancelled = false;
    getFirmById(id).then((loaded) => {
      if (!cancelled) {
        setFirm(loaded);
      }
    }).catch(() => {
      if (!cancelled) {
        setFirm(null);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [id]);
  return firm;
}
